import { render, staticRenderFns } from "./NoAnnex.vue?vue&type=template&id=b83a443c"
import script from "./NoAnnex.vue?vue&type=script&lang=js"
export * from "./NoAnnex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports